<template>
  <div class="footer__certificates">
    <img width="69" height="39" class="certificate certificate__hipaa" src="@/assets/icons/logos/hipaa-mark.svg?url"
      alt="HIPAA Compliant" />
    <img width="50" height="50" class="certificate certificate__gdpr" src="@/assets/icons/logos/gdpr.svg?url"
      alt="GDPR" />
    <img width="48" height="48" class="certificate certificate__iso-13485" src="@/assets/icons/logos/iso.svg?url"
      alt="ISO 13485" />
    <img width="37" height="50" class="certificate certificate__iso-27001" src="@/assets/icons/logos/iso-align.svg?url"
      alt="ISO 27001" />
  </div>
</template>

<style lang="scss" scoped>
.footer {
  &__certificates {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    opacity: 0.8;

    @media (min-width: 380px) {
      justify-content: flex-start;
      gap: 35.2px;
    }

    @media (min-width: $breakpoint-md) {
      gap: 44px;
    }
  }
}

.certificate {
  display: block;
  flex-shrink: 0;
  object-fit: contain;

  &__hipaa {
    width: 54.948px;
    height: 31.29px;

    @media (min-width: $breakpoint-md) {
      width: 68.685px;
      height: 39.112px;
    }
  }

  &__gdpr {
    width: 40px;
    height: 40px;

    @media (min-width: $breakpoint-md) {
      width: 50px;
      height: 50px;
    }
  }

  &__iso-13485 {
    width: 36.8px;
    height: 36.8px;

    @media (min-width: $breakpoint-md) {
      width: 48px;
      height: 48px;
    }
  }

  &__iso-27001 {
    width: 29.873px;
    height: 40px;

    @media (min-width: $breakpoint-md) {
      width: 37.342px;
      height: 50px;
    }
  }
}
</style>
